import { StyledSx } from "src/types/StyledSx";

const SpecificationAccordionStyled: StyledSx = {
  root: {
    boxShadow: "none",
    border: "none",
    "+.Mui-expanded": {
      margin: 0,
    },
    "+.Mui-expanded:before": {
      opacity: 1,
    },
  },
  content: {
    ".MuiAccordionSummary-content": {
      margin: "20px 0",
    },
  },
  textDetail: {
    ".MuiAccordionDetails-root": {
      paddingTop: 0,
      whiteSpace: "pre-wrap",
    },
  },
};

export default SpecificationAccordionStyled;
